<button
	pButton
	pTooltip="Código QR"
	tooltipPosition="top"
	class="p-button-rounded p-button-text flex flex-col items-center justify-center"
	(click)="openDialog()"
>
	<i class="pi pi-qrcode text-[20px]"></i>
	<span class="text-[10px]">{{ qrLabel }}</span>
</button>

<p-dialog
	header="Tu CapyQR"
	[(visible)]="showQRCode"
	[modal]="true"
	[style]="{ width: '340px' }"
	position="bottom"
	[draggable]="false"
>
	<div class="flex flex-col gap-2 items-center">
		<h5 class="mb-1 text-center">
			Mostrá tu CapyQR en caja para sumar beneficios :D
		</h5>
		<qrcode
			[qrdata]="qrData"
			[width]="295"
			[errorCorrectionLevel]="'M'"
		></qrcode>
	</div>
</p-dialog>

<p-dialog
	header="Escaneá el QR del cliente"
	[(visible)]="scanQRCode"
	[modal]="true"
	[style]="{ width: '340px' }"
	position="bottom"
	[draggable]="false"
>
	@if (scanQRCode) {
	<div class="flex flex-col gap-2 items-center">
		<app-qr-scanner (scanned)="onScannedQR($event)" />
	</div>
	}
</p-dialog>
